<script>
export default {
  name: 'AuthFormHeader',
  props: {
    title: {
      type: String,
      required: true,
    }
  },
}
</script>

<template>
    <b-container :class="$style.titleContainer" class="border-bottom px-0">
      <div :class="$style.title" class="m-0">{{ title }}</div>
    </b-container>
</template>

<style lang="scss" module>
@import '@design';
.titleContainer {
  margin-bottom: 20px;
}
.title {
  color: #1F3259;
  font-size: 2.25rem;
  font-weight: $label-font-weight-lg;
  line-height: 2.5rem;
  padding-bottom: 20px;
  letter-spacing: 1.08px;
}
</style>
